export const QUERY_KEY = {
  flow: ['flow'],
  receptionNumber: ['receptionNumber'],
  receptionName: ['receptionName'],
  errorText: ['errorText']
};
